import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import pointerEvent from 'util/dom/pointer-event';


export default class SlidingDoor extends PureComponent {
    static defaultProps = {
        deltaLimit: 40,
        direction: 'both',
        isOpened: false,
        containerStyle: {},
    };

    static propTypes = {
        deltaLimit: PropTypes.number,
        direction: PropTypes.string,
        children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
        isOpened: PropTypes.bool,
        forceClose: PropTypes.bool,
        className: PropTypes.string,
    };

    state = {
        cachedX: 0,
        deltaX: 0,
        isDragging: false,
        className: '',
    };

    componentDidMount() {
        this.toggle(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpened !== this.props.isOpened) {
            this.toggle(nextProps);
        }

        if (nextProps.forceClose) {
            this.setState({
                deltaX: 0,
                isOpened: false,
                isDragging: false,
            });
        }
    }

    drag = (e) => {
        if (!this.state.isDragging) {
            return;
        }

        const pointer = pointerEvent(e);
        const { direction, deltaLimit } = this.props;
        const currentX = pointer.pageX;
        let deltaX = this.state.deltaX + (currentX - this.state.cachedX);

        let min = -deltaLimit;
        let max = deltaLimit;
        switch (direction) {
            case 'left':
                min = -deltaLimit;
                max = 0;
                break;
            case 'right':
                min = 0;
                max = deltaLimit;
                break;
            default:
            // noop
        }

        if (deltaX < min) {
            deltaX = min;
        } else if (deltaX > max) {
            deltaX = max;
        }

        this.setState({
            deltaX,
            cachedX: currentX,
        });
    };

    startDrag = (e) => {
        const pointer = pointerEvent(e);
        this.setState({
            isDragging: true,
            cachedX: pointer.pageX,
        });
    };

    stopDrag = () => {
        const { direction, deltaLimit } = this.props;
        const thresholdFactor = 2;

        let { deltaX } = this.state;
        let min = -deltaLimit / thresholdFactor;
        let max = deltaLimit / thresholdFactor;

        switch (direction) {
            case 'left':
                min = -deltaLimit / thresholdFactor;
                max = 0;
                break;
            case 'right':
                min = 0;
                max = deltaLimit / thresholdFactor;
                break;
            default:
            // noop
        }

        if (deltaX < min) {
            deltaX = min * thresholdFactor;
        } else if (deltaX > max) {
            deltaX = max * thresholdFactor;
        } else {
            deltaX = 0;
        }

        this.setState({
            deltaX,
            isDragging: false,
        });
    };

    toggle(props) {
        const { direction, isOpened, deltaLimit } = props;
        let deltaX = 0;

        if (isOpened) {
            deltaX = direction === 'left' ? -deltaLimit : deltaLimit;
        }

        this.setState({ deltaX });
    }

    render() {
        const { children, className } = this.props;
        const { deltaX, isDragging } = this.state;

        return (
            <div
                ref="root"
                style={{ transform: `translate(${ deltaX }px, 0)` }}
                className={classnames(`sliding-door ${ className }`, {
                    'sliding-door__animate': !isDragging,
                })}
                onTouchStart={this.startDrag}
                onTouchMove={this.drag}
                onTouchEnd={this.stopDrag}>
                { children }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/sliding-door/index.js